/**
 * 购物车变体编辑器
 * 功能：点击购物车中的变体时，弹出快速加车弹窗，将"加购"按钮改为"更新"按钮
 * 独立于原有快速加车功能，互不影响
 */

(function() {
  'use strict';

   // 🔧 关键修复：提供 pushEvent 占位函数，防止报错
  // 问题：主题的 product 实例在切换变体时会调用 pushEvent()
  // 但在购物车编辑弹窗中，这个函数不存在，导致报错
  // 解决：提供一个空的占位函数
  if (typeof window.pushEvent === 'undefined') {
    window.pushEvent = function(data) {
      // 什么都不做，只是防止报错
    };
  }

  // 配置项
  var CartVariantEditor = {
    // 当前正在编辑的购物车项信息
    currentEditingItem: {
      cartItemKey: null,        // 购物车项的key
      productId: null,          // 产品ID
      productHandle: null,      // 产品handle
      variantId: null,          // 当前变体ID
      quantity: 1               // 数量
    },
    
    // 是否正在编辑模式
    isEditMode: false,
    
    // 保存被临时移除的快速加车弹窗DOM
    // 格式：{ productId: { element: DOM元素, parent: 父节点, nextSibling: 下一个兄弟节点 } }
    removedQuickShopModals: {},
    
    // 是否从购物车抽屉打开的编辑弹窗
    openedFromCartDrawer: false,
    
    // 保存关闭事件的监听器引用，防止重复注册
    closeEventHandlers: {},
    
    // 保存modal实例的引用，用于关闭弹窗
    // 格式：{ productId: modalInstance }
    modalInstances: {},
    
    /**
     * 初始化函数
     */
    init: function() {
      this.bindEvents();
    },
    
    /**
     * 绑定事件
     */
    bindEvents: function() {
      var self = this;
      
      // 使用事件委托监听变体点击事件
      $(document).on('click', '[data-variant-toggle]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var $toggle = $(this);
        
        // 获取购物车项信息
        var cartItemKey = $toggle.attr('data-cart-item-key');
        var productId = $toggle.attr('data-product-id');
        var productHandle = $toggle.attr('data-product-handle');
        var variantId = $toggle.attr('data-variant-id');
        var quantity = parseInt($toggle.attr('data-item-quantity')) || 1;
        
        // 保存当前编辑信息
        self.currentEditingItem = {
          cartItemKey: cartItemKey,
          productId: productId,
          productHandle: productHandle,
          variantId: variantId,
          quantity: quantity
        };
        
        // 设置为编辑模式
        self.isEditMode = true;
        
        // 加载产品弹窗
        self.loadProductModal(productHandle, productId, variantId);
      });
    },
    
    /**
     * 加载产品弹窗
     * 完全复制 theme.preloadProductModal 的逻辑，然后添加自定义功能
     * @param {string} handle - 产品handle
     * @param {string} productId - 产品ID
     * @param {string} variantId - 要选中的变体ID
     */
    loadProductModal: function(handle, productId, variantId) {
      var self = this;
      
      
      // 🔧 检查是否从购物车抽屉打开
      this.openedFromCartDrawer = this.isCartDrawerOpen();
      
      // 🔧 关键修复：打开购物车编辑弹窗前，临时移除快速加车弹窗
      // 防止变体切换事件影响快速加车弹窗
      this.removeQuickShopModal(productId);
      
      // 使用购物车变体编辑器的独立holder
      var holderId = 'CartVariantEditorHolder-' + handle;
      var modalId = 'CartVariantEditorModal-' + productId;
      
      
      var holder = document.getElementById(holderId);
      
      if (!holder) {
        console.error('❌ 找不到holder:', holderId);
        
        // 🔧 检查是否存在快速加车的holder
        var quickShopHolderId = 'QuickShopHolder-' + handle;
        var quickShopHolder = document.getElementById(quickShopHolderId);
        if (quickShopHolder) {
          console.warn('⚠️ 发现快速加车holder:', quickShopHolderId);
          console.warn('⚠️ 这可能是问题的原因！');
        }
        
        alert('无法打开编辑弹窗，请刷新页面重试');
        return;
      }
      
      
      
      // 完全按照theme.preloadProductModal的方式构建URL
      var url = theme.routes.home + '/products/' + handle + '?view=modal';
      
      // remove double `/` in case shop might have /en or language in URL
      url = url.replace('//', '/');
      
      
      // 完全按照theme.preloadProductModal的方式加载
      fetch(url).then(function(response) {
        return response.text();
      }).then(function(html) {
        
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var div = doc.querySelector('.product-section[data-product-handle="'+handle+'"]');
        
        if (!holder) {
          return;
        }
        
        if (!div) {
          console.error('❌ 未找到product-section');
          alert('产品加载失败，请重试');
          return;
        }
        
        // 🔧 关键修复：修改 section-id，避免与快速加车弹窗冲突
        // 问题：快速加车和购物车编辑使用相同的 section-id，导致实例冲突
        // 解决：给购物车编辑弹窗一个唯一的 section-id
        var originalSectionId = div.getAttribute('data-section-id');
        var newSectionId = 'cart-variant-editor-' + originalSectionId;
        
        
        div.setAttribute('data-section-id', newSectionId);
        
        // 同时修改 id 属性（如果存在）
        var originalId = div.getAttribute('id');
        if (originalId) {
          var newId = originalId.replace(originalSectionId, newSectionId);
          div.setAttribute('id', newId);
        }
        
        holder.innerHTML = '';
        
        holder.append(div);
        
        
        // 关键修复：修改product-section的引用，让theme.Product能找到正确的modal
        var productSection = div;
        var originalDataModal = productSection.getAttribute('data-modal');
        
        
        // 如果是modal模式，需要让theme.Product能找到我们的modal
        if (originalDataModal === 'true') {
          
          // 临时修改product-section的dataset，让它能找到我们的modal
          // 在product-section插入到DOM后，手动设置modal引用
          // 这样theme.Product.init()中的this.modal就能正确指向我们的modal
        }
        
        // Setup quick view modal（完全按照theme.js）
        var name = 'cart-variant-editor-modal-' + productId;
        
        
        // 检查modal元素是否存在
        if (!document.getElementById(modalId)) {
          console.error('❌ Modal元素不存在:', modalId);
          alert('弹窗元素未找到，请刷新页面');
          return;
        }
        
        var modalInstance = new theme.Modals(modalId, name);
        
        // 🔧 关键修复：保存modal实例的引用，用于后续关闭弹窗
        // 问题：在线上环境中，通过点击关闭按钮可能无法正确关闭弹窗
        // 解决：保存modal实例，直接调用close()方法
        self.modalInstances[productId] = modalInstance;
        
        // Register product template inside quick view（完全按照theme.js）
        theme.sections.register('product', theme.Product, holder);
        
        // 关键修复：手动修复theme.Product实例的modal引用
        // theme.Product在init时会尝试获取QuickShopModal，但找不到
        // 我们需要手动修复这个引用
        if (originalDataModal === 'true') {
          // 查找刚刚创建的product实例
          var productInstance = self.findProductInstance(productSection.getAttribute('data-section-id'));
          if (productInstance) {
            productInstance.modal = document.getElementById(modalId);
          } else {
            console.warn('⚠️ 未找到product实例');
          }
        }
        
        // Register collapsible elements（完全按照theme.js）
        theme.collapsibles.init();
        
        // Register potential video modal links (when video has sound)（完全按照theme.js）
        theme.videoModal();
        
        // Register collapsible elements（完全按照theme.js）
        theme.collapsibles.init();
        
        // Register potential video modal links (when video has sound)（完全按照theme.js）
        theme.videoModal();
        
        
        // 🔧 关键修复：添加事件隔离层，防止与快速加车弹窗冲突
        // 问题：快速加车弹窗的product实例监听了change事件
        // 当购物车编辑弹窗切换变体时，change事件会冒泡到快速加车弹窗
        // 快速加车弹窗尝试调用 pushEvent，导致错误
        // 解决：在购物车编辑弹窗的最外层容器上拦截change事件，阻止向外冒泡
        var modalElement = document.getElementById(modalId);
        if (modalElement) {
          // 在冒泡阶段拦截change事件，阻止向快速加车弹窗冒泡
          // 但允许购物车编辑弹窗内部的监听器正常接收事件
          modalElement.addEventListener('change', function(e) {
            
            // 关键：停止事件继续向外冒泡
            // 但不阻止默认行为，允许内部监听器正常工作
            e.stopPropagation();
          }, false); // 使用冒泡阶段，在内部监听器处理完后再拦截
          
        } else {
          console.warn('⚠️ 未找到modal元素，无法添加事件隔离层');
        }
        
        // 关键修复：立即查找product实例并修复modal引用
        var sectionId = productSection.getAttribute('data-section-id');
        
        // 先添加事件监听器，再打开弹窗（确保事件能被捕获）
        var productInstance = self.findProductInstance(sectionId);
        if (productInstance) {
          
          // 如果是modal模式，修复modal引用（关键！）
          if (productInstance.inModal) {
            productInstance.modal = document.getElementById(modalId);
            
            // 关键：添加事件监听器，当弹窗打开时调用openModalProduct
            document.addEventListener('modalOpen.CartVariantEditorModal-' + productId, function() {
              if (typeof productInstance.openModalProduct === 'function') {
                productInstance.openModalProduct();
              } else {
                console.error('❌ openModalProduct方法不存在');
              }
            });
            
            // 监听关闭事件
            document.addEventListener('modalClose.CartVariantEditorModal-' + productId, function() {
              if (typeof productInstance.closeModalProduct === 'function') {
                productInstance.closeModalProduct();
              }
            });
          }
        } else {
          console.warn('⚠️ 未找到product实例');
        }
        
        // 🔧 使用重试机制，确保按钮能被找到
        var retryCount = 0;
        var maxRetries = 30; // 最多重试10次
        var retryDelay = 200; // 每次间隔200ms
        
        function trySelectVariantAndModifyButton() {
          
          var button = holder.querySelector('[data-add-to-cart]');
          if (button) {
            self.selectVariantAndModifyButton(holder, variantId, productId);
          } else {
            retryCount++;
            if (retryCount < maxRetries) {
              setTimeout(trySelectVariantAndModifyButton, retryDelay);
            } else {
              console.error('❌ 达到最大重试次数，按钮仍未出现');
            }
          }
        }
        
        // 延迟一点再开始第一次尝试，让DOM有时间渲染
        setTimeout(trySelectVariantAndModifyButton, 300);
        
        // 打开弹窗
        setTimeout(function() {
          
          // 打开弹窗
          if (modalInstance && typeof modalInstance.open === 'function') {
            try {
              modalInstance.open();
              
            } catch(e) {
              console.error('❌ 打开弹窗失败:', e);
            }
          } else {
            console.error('❌ modalInstance或open方法不存在');
          }
        }, 300);
        
      }).catch(function(error) {
        console.error('❌ 加载失败:', error);
        alert('产品加载失败: ' + error.message);
      });
    },
    
    /**
     * 选中指定变体并修改按钮
     * @param {Element} holder - 产品容器
     * @param {string} variantId - 要选中的变体ID
     * @param {string} productId - 产品ID
     */
    selectVariantAndModifyButton: function(holder, variantId, productId) {
      var self = this;
      
      // 检查holder是否有效
      if (!holder) {
        console.error('❌ holder为空，无法继续');
        return;
      }
      
      var variantSelected = false;
      
      // 方法1: 如果是下拉选择器（直接选择variant ID）
      var selectElement = holder.querySelector('select[name="id"]');
      if (selectElement) {
        
        // 重要：强制设置值
        selectElement.value = String(variantId);
        
        // 检查是否设置成功
        if (selectElement.value == variantId) {
          console.log('✅ 变体ID设置成功');
        } else {
          console.warn('⚠️ 变体ID设置失败，当前值仍为:', selectElement.value);
          // 尝试强制选择option
          var options = selectElement.options;
          for (var i = 0; i < options.length; i++) {
            if (options[i].value == variantId) {
              options[i].selected = true;
              break;
            }
          }
        }
        
        // 触发change事件，让主题JS更新价格、库存等信息
        // 方法1: 原生事件
        var changeEvent = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(changeEvent);
        
        // 方法2: jQuery事件（如果主题使用jQuery监听）
        if (typeof $ !== 'undefined' && $(selectElement).length > 0) {
          $(selectElement).trigger('change');
        }
        
        
        // 关键修复：手动触发 variantChange 和 variant:change 事件
        // 这是主题用来更新UI（颜色按钮、图片、价格等）的事件
        setTimeout(function() {
          
          // 获取产品数据
          var productData = self.getProductData(holder);
          if (productData && productData.variants) {
            // 查找对应的变体对象
            var targetVariant = null;
            for (var i = 0; i < productData.variants.length; i++) {
              if (productData.variants[i].id == variantId) {
                targetVariant = productData.variants[i];
                break;
              }
            }
            
            if (targetVariant) {
              
              // 构造 detail 数据（参考 theme.js line 974-979）
              var detail = {
                variant: targetVariant,
                currentlySelectedValues: [
                  {value: targetVariant.option1, index: 'option1'},
                  {value: targetVariant.option2, index: 'option2'},
                  {value: targetVariant.option3, index: 'option3'}
                ].filter(function(opt) { return opt.value; }),
                value: String(variantId),
                index: 'id'
              };
              
              
              // 查找产品容器
              var productSection = holder.querySelector('.product-section') || 
                                  holder.closest('.product-section');
              
              if (productSection) {
                // 触发 variantChange 事件（在容器上）
                var variantChangeEvent = new CustomEvent('variantChange', {
                  detail: detail,
                  bubbles: true
                });
                productSection.dispatchEvent(variantChangeEvent);
                
                // 触发 variant:change 事件（在 document 上）
                var variantChangeGlobalEvent = new CustomEvent('variant:change', {
                  detail: detail,
                  bubbles: true
                });
                document.dispatchEvent(variantChangeGlobalEvent);
              } else {
                console.warn('⚠️ 未找到产品容器，无法触发variantChange事件');
              }
            } else {
              console.warn('⚠️ 未找到变体对象');
            }
          } else {
            console.warn('⚠️ 无法获取产品数据，跳过variantChange事件');
          }
        }, 150);
        
        variantSelected = true;
      }
      
      // 方法2: 如果是单选按钮（radio buttons，直接选择variant ID）
      var radioInput = holder.querySelector('input[name="id"][value="' + variantId + '"]');
      if (radioInput) {
        radioInput.checked = true;
        var changeEvent = new Event('change', { bubbles: true });
        radioInput.dispatchEvent(changeEvent);
        variantSelected = true;
      } else {
        console.log('⚠️ 未找到单选按钮');
      }
      
      // 方法3: 如果是选项按钮（option buttons，如颜色、尺寸按钮）
      // 需要根据variantId找到对应的选项组合
      
      // 无论是否已选中，都调用selectVariantOptions以确保UI状态一致
      try {
        self.selectVariantOptions(holder, variantId);
      } catch (e) {
        console.error('❌ selectVariantOptions执行失败:', e);
      }
      
      // 修改加购按钮为更新按钮
      // 尝试多种选择器查找按钮
      var buttonSelectors = [
        '[data-add-to-cart]',
        'button[name="add"]',
        '.add-to-cart',
        'form[action*="/cart/add"] button[type="submit"]',
        '.product-form__cart-submit',
        '[data-add-to-cart-text]'
      ];
      
      var addToCartButton = null;
      for (var i = 0; i < buttonSelectors.length; i++) {
        addToCartButton = holder.querySelector(buttonSelectors[i]);
        if (addToCartButton) {
          break;
        }
      }
      
      if (addToCartButton) {
        
        // 移除原有的点击事件（通过克隆按钮）
        var newButton = addToCartButton.cloneNode(true);
        addToCartButton.parentNode.replaceChild(newButton, addToCartButton);
        
        // 修改按钮文本
        var buttonText = newButton.querySelector('[data-add-to-cart-text]');
        if (buttonText) {
          buttonText.textContent = 'UPDATE';
          buttonText.setAttribute('data-default-text', 'UPDATE');
        } else {
          newButton.textContent = 'UPDATE';
        }
        
        // 添加编辑模式标识class
        newButton.classList.add('cart-variant-editor__update-btn');
        
        // 绑定更新事件
        $(newButton).on('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          self.handleUpdate(holder, productId);
        });
        
      } else {
        console.error('❌ 未找到加购按钮！所有尝试都失败了');
      }
      
      // 监听弹窗关闭事件（由theme.Modals触发）
      // 当弹窗关闭时，重置编辑模式并还原快速加车弹窗
      // 🔧 防止重复注册：先移除旧的监听器，再添加新的
      var closeEventName = 'modalClose.CartVariantEditorModal-' + productId;
      
      // 如果已有监听器，先移除
      if (self.closeEventHandlers[productId]) {
        document.removeEventListener(closeEventName, self.closeEventHandlers[productId]);
      }
      
      // 创建新的监听器
      self.closeEventHandlers[productId] = function(event) {
        
        // 还原快速加车弹窗DOM
        self.restoreQuickShopModal(productId);
        
        // 🔧 如果是从购物车抽屉打开的，关闭后重新打开购物车抽屉
        if (self.openedFromCartDrawer) {
          setTimeout(function() {
            self.reopenCartDrawer();
          }, 200);
        }
        
        self.resetEditMode();
        
        // 清理：移除这个监听器
        document.removeEventListener(closeEventName, self.closeEventHandlers[productId]);
        delete self.closeEventHandlers[productId];
      };
      
      // 添加监听器
      document.addEventListener(closeEventName, self.closeEventHandlers[productId]);
    },
    
    /**
     * 根据variantId选中对应的选项按钮
     * @param {Element} holder - 产品容器
     * @param {string} variantId - 变体ID
     */
    selectVariantOptions: function(holder, variantId) {
      
      // 获取产品数据
      var productData = this.getProductData(holder);
      
      if (!productData || !productData.variants) {
        return;
      }
      
      
      // 找到对应的变体
      var targetVariant = null;
      for (var i = 0; i < productData.variants.length; i++) {
        if (productData.variants[i].id == variantId) {
          targetVariant = productData.variants[i];
          break;
        }
      }
      
      if (!targetVariant) {
        return;
      }

      
      // 选中对应的选项
      if (targetVariant.option1) {
        this.selectOption(holder, 'option1', targetVariant.option1);
      }
      if (targetVariant.option2) {
        this.selectOption(holder, 'option2', targetVariant.option2);
      }
      if (targetVariant.option3) {
        this.selectOption(holder, 'option3', targetVariant.option3);
      }
    },
    
    /**
     * 选中指定选项
     * @param {Element} holder - 产品容器
     * @param {string} optionName - 选项名称（option1, option2, option3）
     * @param {string} optionValue - 选项值
     */
    selectOption: function(holder, optionName, optionValue) {
      
      var selected = false;
      
      // 方法1: 尝试多种选择器属性查找下拉选择器
      var selectors = [
        'select[data-index="' + optionName + '"]',
        'select[name="' + optionName + '"]',
        'select[id*="' + optionName + '"]'
      ];
      
      for (var i = 0; i < selectors.length; i++) {
        var optionSelector = holder.querySelector(selectors[i]);
        if (optionSelector) {
          optionSelector.value = optionValue;
          
          // 触发change事件（允许冒泡，但会被modal容器拦截）
          var changeEvent = new Event('change', { 
            bubbles: true,  // 允许冒泡到购物车编辑弹窗的product实例
            cancelable: true 
          });
          optionSelector.dispatchEvent(changeEvent);
          
          // 手动触发jQuery事件（如果需要）
          if (window.jQuery) {
            jQuery(optionSelector).trigger('change');
          }
          
          selected = true;
          return;
        }
      }
      
      // 方法2: 查找单选按钮
      var radioSelectors = [
        'input[name="' + optionName + '"]',
        'input[type="radio"][data-index="' + optionName + '"]'
      ];
      
      for (var i = 0; i < radioSelectors.length; i++) {
        var radioInputs = holder.querySelectorAll(radioSelectors[i]);
        if (radioInputs.length > 0) {
          radioInputs.forEach(function(input) {
            if (input.value === optionValue) {
              input.checked = true;
              
              // 触发change事件（允许冒泡，但会被modal容器拦截）
              var changeEvent = new Event('change', { 
                bubbles: true,  // 允许冒泡到购物车编辑弹窗的product实例
                cancelable: true 
              });
              input.dispatchEvent(changeEvent);
              
              selected = true;
            }
          });
          if (selected) return;
        }
      }
      
      // 方法3: 查找选项按钮（variant-input样式的按钮）
      // 这种情况下，选项按钮可能带有data-value属性
      var optionButtons = holder.querySelectorAll('[data-option-index="' + optionName + '"]');
      if (optionButtons.length > 0) {
        optionButtons.forEach(function(button) {
          if (button.getAttribute('data-value') === optionValue || button.textContent.trim() === optionValue) {
            button.click();
            selected = true;
          }
        });
        if (selected) return;
      }
      
      if (!selected) {
        console.warn('❌ 未找到选项选择器:', optionName, '(尝试了下拉、单选、按钮)');
      }
    },
    
    /**
     * 从产品容器中获取产品数据
     * @param {Element} holder - 产品容器
     * @returns {Object|null} 产品数据
     */
    getProductData: function(holder) {
      
      // 方法1: 从 data-product-json 属性获取
      var productJsonEl = holder.querySelector('[data-product-json]');
      if (productJsonEl) {
        try {
          var data = JSON.parse(productJsonEl.textContent);
          return data;
        } catch (e) {
          console.error('❌ 解析[data-product-json]失败:', e);
        }
      } else {
        console.warn('⚠️ 未找到[data-product-json]元素');
      }
      
      // 方法2: 从 script[type="application/json"] 获取
      var scriptTags = holder.querySelectorAll('script[type="application/json"]');
      if (scriptTags.length > 0) {
        for (var i = 0; i < scriptTags.length; i++) {
          try {
            var data = JSON.parse(scriptTags[i].textContent);
            if (data.variants && data.variants.length > 0) {
              return data;
            }
          } catch (e) {
            console.warn('解析script标签失败:', e);
          }
        }
      } else {
        console.warn('⚠️ 未找到script[type="application/json"]元素');
      }
      
      // 方法3: 尝试从product-section的data属性获取
      var productSection = holder.querySelector('.product-section');
      if (!productSection) {
        productSection = holder.closest('.product-section');
      }
      
      if (productSection) {
        // 再次尝试查找JSON数据
        var jsonEl = productSection.querySelector('[data-product-json], script[type="application/json"]');
        if (jsonEl) {
          try {
            var data = JSON.parse(jsonEl.textContent);
            return data;
          } catch (e) {
            console.error('❌ 解析失败:', e);
          }
        }
      }
      
      // 方法4: 尝试从全局变量获取
      if (typeof theme !== 'undefined' && theme.productData) {
        return theme.productData;
      }
      
      console.error('❌ 无法获取产品数据');
      return null;
    },
    
    /**
     * 处理更新操作
     * @param {Element} holder - 产品容器
     * @param {string} productId - 产品ID
     */
    handleUpdate: function(holder, productId) {
      var self = this;
      
      
      // 获取表单
      var form = holder.querySelector('form[action*="/cart/add"], .product-single__form');
      if (!form) {
        console.error('❌ [DEBUG] 无法找到产品表单');
        alert('无法找到产品表单');
        return;
      }
      
      // 获取新选中的变体ID
      var newVariantId = null;
      var variantInput = form.querySelector('select[name="id"], input[name="id"]:checked');
      if (variantInput) {
        newVariantId = variantInput.value;
      } else {
        console.warn('⚠️ [DEBUG] 未找到变体输入');
      }
      
      if (!newVariantId) {
        console.error('❌ [DEBUG] 未选择变体');
        alert('请选择一个变体');
        return;
      }
      
      
      // 如果变体未改变，直接关闭弹窗
      if (newVariantId == self.currentEditingItem.variantId) {
        self.closeModal(productId);
        return;
      }
      
      // 获取数量
      var quantity = self.currentEditingItem.quantity || 1;
      
      // 禁用更新按钮，显示加载状态
      var updateButton = holder.querySelector('.cart-variant-editor__update-btn');
      if (updateButton) {
        updateButton.disabled = true;
        var originalText = updateButton.textContent;
        updateButton.textContent = 'UPDATING...';
      } else {
        console.warn('⚠️ [DEBUG] 未找到更新按钮');
      }
      
      // 执行更新：先删除旧的，再添加新的
      self.updateCartItem(
        self.currentEditingItem.cartItemKey,
        newVariantId,
        quantity
      ).then(function() {
        
        // 先重新加载购物车（确保数据更新）
        // 如果是从购物车抽屉打开的，抑制自动打开，我们稍后会手动打开
        self.reloadCart(self.openedFromCartDrawer);
        
        // 延迟关闭弹窗，确保购物车数据已更新
        setTimeout(function() {
          if (self.modalInstances[productId]) {
          }
          self.closeModal(productId);
          
          // 🔧 如果是从购物车抽屉打开的，在关闭弹窗后再次确保购物车抽屉打开
          if (self.openedFromCartDrawer) {
            setTimeout(function() {
              self.reopenCartDrawer();
            }, 300);
          }
        }, 300);
        
        // 显示成功提示
        if (typeof theme !== 'undefined' && theme.NotificationPopup) {
          theme.NotificationPopup.open('success', 'Cart updated successfully');
        } else {
          console.warn('⚠️ [DEBUG] NotificationPopup不存在，跳过提示');
        }
      }).catch(function(error) {
        console.error('❌ [DEBUG] updateCartItem Promise reject - 更新失败');
        console.error('  - error:', error);
        console.error('  - error.message:', error.message);
        console.error('  - error.stack:', error.stack);
        alert('更新失败，请重试');
        
        // 恢复按钮状态
        if (updateButton) {
          updateButton.disabled = false;
          updateButton.textContent = originalText;
        }
      });
    },
    
    /**
     * 更新购物车项（删除旧的，添加新的）
     * @param {string} oldCartItemKey - 旧的购物车项key
     * @param {string} newVariantId - 新的变体ID
     * @param {number} quantity - 数量
     * @returns {Promise}
     */
    updateCartItem: function(oldCartItemKey, newVariantId, quantity) {
      var self = this;
      
      
      return new Promise(function(resolve, reject) {
        // 第一步：删除旧的购物车项（设置数量为0）
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: oldCartItemKey,
            quantity: 0
          })
        })
        .then(function(response) {
          if (!response.ok) {
            console.error('❌ [DEBUG] 删除请求失败:', response.status);
            throw new Error('Failed to remove old item');
          }
          return response.json();
        })
        .then(function(data) {
          
          // 第二步：添加新的变体
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: newVariantId,
              quantity: quantity
            })
          });
        })
        .then(function(response) {
          if (!response.ok) {
            console.error('❌ [DEBUG] 添加请求失败:', response.status);
            throw new Error('Failed to add new item');
          }
          return response.json();
        })
        .then(function(data) {
          resolve();
        })
        .catch(function(error) {
          console.error('❌ [DEBUG] updateCartItem 发生错误');
          console.error('  - error:', error);
          console.error('  - error.message:', error.message);
          console.error('  - error.stack:', error.stack);
          reject(error);
        });
      });
    },
    
    /**
     * 关闭弹窗
     * @param {string} productId - 产品ID
     */
    closeModal: function(productId) {
      var self = this;
      var modalId = 'CartVariantEditorModal-' + productId;
      
      
      // 🔧 关键修复：优先使用保存的modal实例来关闭弹窗
      // 方法1：直接调用modal实例的close方法（最可靠）
      var modalInstance = this.modalInstances[productId];
      if (modalInstance) {
      }
      
      if (modalInstance && typeof modalInstance.close === 'function') {
        try {
          // 调用close方法，不传参数（evt参数是可选的）
          modalInstance.close();
        } catch(e) {
          console.error('❌ [DEBUG] 调用modalInstance.close()失败');
          console.error('  - error:', e);
          console.error('  - error.message:', e.message);
          console.error('  - error.stack:', e.stack);
          // 如果失败，尝试备用方法
          self.closeModalFallback(productId, modalId);
        }
      } else {
        console.warn('⚠️ [DEBUG] 未找到modal实例或close方法不存在');
        console.warn('  - modalInstance存在:', !!modalInstance);
        if (modalInstance) {
          console.warn('  - close方法类型:', typeof modalInstance.close);
        }
        // 方法2：备用方法 - 点击关闭按钮
        self.closeModalFallback(productId, modalId);
      }
      
      // 🔧 还原快速加车弹窗DOM
      this.restoreQuickShopModal(productId);
      
      // 🔧 如果是从购物车抽屉打开的，关闭后重新打开购物车抽屉
      if (this.openedFromCartDrawer) {
        setTimeout(function() {
          self.reopenCartDrawer();
        }, 200);
      }
      
      // resetEditMode 会在 modalClose 事件中调用
      
      // 清理：移除保存的modal实例引用
      if (this.modalInstances[productId]) {
        delete this.modalInstances[productId];
      } else {
        console.warn('⚠️ [DEBUG] modal实例引用不存在，无法清理');
      }
      
      // 检查弹窗是否真的关闭了
      setTimeout(function() {
        var modalElement = document.getElementById(modalId);
        if (modalElement) {
          var isActive = modalElement.classList.contains('modal--is-active');
          var isClosing = modalElement.classList.contains('modal--is-closing');
          if (isActive) {
            console.warn('⚠️ [DEBUG] 弹窗仍然处于激活状态！');
          }
        } else {
          console.log('✅ [DEBUG] 弹窗元素已不存在（可能已从DOM移除）');
        }
      }, 500);
    },
    
    /**
     * 关闭弹窗的备用方法（当modal实例不可用时使用）
     * @param {string} productId - 产品ID
     * @param {string} modalId - 弹窗ID
     */
    closeModalFallback: function(productId, modalId) {
      
      var modal = document.getElementById(modalId);
      
      if (modal) {
        
        // 方法1：尝试点击关闭按钮
        var closeButton = modal.querySelector('.js-modal-close');
        if (closeButton) {
        }
        
        if (closeButton) {
          try {
            closeButton.click();
            
            // 检查点击后的状态
            setTimeout(function() {
              var isActive = modal.classList.contains('modal--is-active');
              if (isActive) {
                console.warn('⚠️ [DEBUG] 点击关闭按钮后弹窗仍然激活！');
              }
            }, 200);
            return;
          } catch(e) {
            console.error('❌ [DEBUG] 点击关闭按钮失败:', e);
          }
        }
        
        // 方法2：手动移除打开class并触发关闭事件
        modal.classList.remove('modal--is-active');
        modal.classList.add('modal--is-closing');
        
        // 触发关闭事件
        var closeEventName = 'modalClose.' + modalId;
        document.dispatchEvent(new CustomEvent(closeEventName));
        
        // 延迟移除closing class
        setTimeout(function() {
          modal.classList.remove('modal--is-closing');
        }, 500);
      } else {
        console.error('❌ [DEBUG] 未找到modal元素:', modalId);
        console.error('  - 尝试查找所有包含"CartVariantEditorModal"的元素:');
        var allModals = document.querySelectorAll('[id*="CartVariantEditorModal"]');
        console.error('  - 找到', allModals.length, '个相关元素');
        allModals.forEach(function(m) {
          console.error('    -', m.id);
        });
      }
    },
    
    /**
     * 重新加载购物车
     * 参考theme.js中快速加车成功后的逻辑
     * @param {boolean} suppressOpen - 是否抑制自动打开购物车抽屉
     */
    reloadCart: function(suppressOpen) {
      
      // 🔧 如果是从购物车抽屉打开的，并且需要抑制自动打开
      // 我们只更新购物车内容，不触发ajaxProduct:added事件（该事件会自动打开购物车抽屉）
      if (suppressOpen && this.openedFromCartDrawer) {
        
        // 只触发cart:build事件，不触发ajaxProduct:added
        var buildEvent = new CustomEvent('cart:build');
        document.dispatchEvent(buildEvent);
        
        // 直接调用购物车的buildCart方法
        if (typeof theme !== 'undefined' && theme.cart && theme.cart.cartForm) {
          theme.cart.cartForm.buildCart();
        } else {
          console.warn('⚠️ [DEBUG] theme.cart.cartForm 不存在');
        }
        return;
      }
      
      // 方法1：触发ajaxProduct:added事件（推荐）
      // 这是快速加车成功后触发的事件，购物车抽屉会监听并更新
      // theme.js line 4122: document.addEventListener('ajaxProduct:added', function(evt) { this.cartForm.buildCart(); this.open(); })
      var event = new CustomEvent('ajaxProduct:added', {
        detail: {
          source: 'cart-variant-editor'
        }
      });
      document.dispatchEvent(event);
      
      // 方法2：触发cart:build事件（备用）
      var buildEvent = new CustomEvent('cart:build');
      document.dispatchEvent(buildEvent);
      
      // 方法3：直接调用购物车的buildCart方法（兜底）
      if (typeof theme !== 'undefined' && theme.cart && theme.cart.cartForm) {
        theme.cart.cartForm.buildCart();
      } else {
        console.warn('⚠️ [DEBUG] theme.cart.cartForm 不存在');
      }
      
      // 如果是购物车页面，延迟刷新页面
      // 注意：购物车抽屉打开时也可能在购物车页面，让用户看到更新后再刷新
      // var isCartPage = window.location.pathname.indexOf('/cart') !== -1;
      // if (isCartPage) {
      //   setTimeout(function() {
      //     window.location.reload();
      //   }, 1000); // 延迟1秒，确保用户能看到抽屉更新
      // }
      
    },
    
    /**
     * 将所有购物车变体编辑弹窗移动到body最外层
     * 解决购物车抽屉中弹窗无法显示的问题
     */
    moveModalsToBody: function() {
      // 查找所有购物车变体编辑弹窗
      var modals = document.querySelectorAll('.modal--cart-variant-editor');
      
      if (modals.length === 0) {
        return;
      }
      
      
      modals.forEach(function(modal) {
        // 检查是否已经在body下
        if (modal.parentNode === document.body) {
          return;
        }
        
        document.body.appendChild(modal);
      });
      
    },
    
    /**
     * 查找产品实例（从theme.sections.instances中查找）
     * @param {string} sectionId - section ID
     * @returns {Object|null} 产品实例
     */
    findProductInstance: function(sectionId) {
      if (typeof theme === 'undefined' || !theme.sections || !theme.sections.instances) {
        return null;
      }
      
      for (var i = 0; i < theme.sections.instances.length; i++) {
        if (theme.sections.instances[i].id === sectionId) {
          return theme.sections.instances[i];
        }
      }
      
      return null;
    },
    
    /**
     * 临时移除快速加车弹窗DOM
     * @param {string} productId - 产品ID
     */
    removeQuickShopModal: function(productId) {
      
      // 可能的快速加车弹窗ID格式
      var possibleModalIds = [
        'QuickShopModal-' + productId,
        'quick-shop-modal-' + productId,
        'quickshop-modal-' + productId
      ];
      
      
      // 先列出页面上所有可能的modal
      var allModals = document.querySelectorAll('[id*="Modal"], [id*="modal"]');
      
      for (var i = 0; i < possibleModalIds.length; i++) {
        var modalId = possibleModalIds[i];
        var modal = document.getElementById(modalId);
        
        if (modal) {
          
          // 保存DOM信息以便后续还原
          this.removedQuickShopModals[productId] = {
            element: modal,
            parent: modal.parentNode,
            nextSibling: modal.nextSibling
          };
          
          // 从DOM中移除
          modal.parentNode.removeChild(modal);
          
          return;
        } else {
          console.log('  ❌ 未找到:', modalId);
        }
      }
      
    },
    
    /**
     * 还原快速加车弹窗DOM
     * @param {string} productId - 产品ID
     */
    restoreQuickShopModal: function(productId) {
      var savedModal = this.removedQuickShopModals[productId];
      
      if (!savedModal) {
        return;
      }
      
      
      try {
        // 还原到原来的位置
        if (savedModal.nextSibling) {
          savedModal.parent.insertBefore(savedModal.element, savedModal.nextSibling);
        } else {
          savedModal.parent.appendChild(savedModal.element);
        }
        
        
        // 清除保存的信息
        delete this.removedQuickShopModals[productId];
      } catch (e) {
        console.error('❌ 还原快速加车弹窗失败:', e);
      }
    },
    
    /**
     * 检查购物车抽屉是否打开
     * @returns {boolean} 购物车抽屉是否打开
     */
    isCartDrawerOpen: function() {
      // 可能的购物车抽屉选择器
      var cartDrawerSelectors = [
        '#CartDrawer',
        '.cart-drawer',
        '[data-cart-drawer]',
        '.drawer--cart',
        '#cart-drawer',
        '.drawer--right' // 有些主题使用这个
      ];
      
      for (var i = 0; i < cartDrawerSelectors.length; i++) {
        var drawer = document.querySelector(cartDrawerSelectors[i]);
        if (drawer) {
          // 检查抽屉是否有打开的class或属性
          var isOpen = drawer.classList.contains('is-open') ||
                       drawer.classList.contains('is-active') ||
                       drawer.classList.contains('drawer--is-open') ||
                       drawer.classList.contains('active') ||
                       drawer.classList.contains('open') ||
                       drawer.getAttribute('aria-hidden') === 'false';
          
          if (isOpen) {
            return true;
          }
        }
      }
      
      return false;
    },
    
    /**
     * 重新打开购物车抽屉
     */
    reopenCartDrawer: function() {
      
      // 方法1: 尝试通过theme.cart对象打开
      if (typeof theme !== 'undefined' && theme.cart) {
        if (typeof theme.cart.open === 'function') {
          theme.cart.open();
          return;
        }
      }
      
      // 方法2: 尝试触发打开购物车的按钮点击
      var cartToggleButtons = document.querySelectorAll('[data-cart-toggle], .js-drawer-open-cart, [data-drawer-toggle="cart"]');
      if (cartToggleButtons.length > 0) {
        cartToggleButtons[0].click();
        return;
      }
      
      // 方法3: 手动添加打开的class
      var cartDrawerSelectors = [
        '#CartDrawer',
        '.cart-drawer',
        '[data-cart-drawer]',
        '.drawer--cart',
        '#cart-drawer'
      ];
      
      for (var i = 0; i < cartDrawerSelectors.length; i++) {
        var drawer = document.querySelector(cartDrawerSelectors[i]);
        if (drawer) {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          
          // 显示overlay
          var overlay = document.querySelector('.drawer-overlay, .drawer__overlay, [data-drawer-overlay]');
          if (overlay) {
            overlay.classList.add('is-visible');
          }
          return;
        }
      }
      
      console.warn('⚠️ 无法重新打开购物车抽屉');
    },
    
    /**
     * 重置编辑模式
     */
    resetEditMode: function() {
      this.isEditMode = false;
      this.currentEditingItem = {
        cartItemKey: null,
        productId: null,
        productHandle: null,
        variantId: null,
        quantity: 1
      };
      
      // 重置购物车抽屉标记
      this.openedFromCartDrawer = false;
      
      // 清理modal实例引用（如果还有残留）
      // 注意：这里不强制清理，因为closeModal中已经清理了
      // 这里只是作为额外的清理措施
    }
  };
  
  // 当DOM加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      CartVariantEditor.init();
      CartVariantEditor.moveModalsToBody();
    });
  } else {
    CartVariantEditor.init();
    CartVariantEditor.moveModalsToBody();
  }
  
  // 监听多个可能的购物车更新事件
  document.addEventListener('cart:updated', function() {
    setTimeout(function() {
      CartVariantEditor.moveModalsToBody();
    }, 100);
  });
  
  document.addEventListener('cart:build', function() {
    setTimeout(function() {
      CartVariantEditor.moveModalsToBody();
    }, 100);
  });
  
  // 使用MutationObserver监听购物车商品容器的变化
  var observeCartProducts = function() {
    var cartProductsContainers = document.querySelectorAll('[data-products]');
    
    cartProductsContainers.forEach(function(container) {
      var observer = new MutationObserver(function(mutations) {
        setTimeout(function() {
          CartVariantEditor.moveModalsToBody();
        }, 200);
      });
      
      observer.observe(container, {
        childList: true,
        subtree: true
      });
      
    });
  };
  
  // 延迟执行observer设置，确保DOM完全加载
  setTimeout(function() {
    observeCartProducts();
  }, 1000);
  
  
  // 暴露到全局，方便调试
  window.CartVariantEditor = CartVariantEditor;
  
})();

